declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}

type GtagFn = (...args: any[]) => void;

export function initAnalytics() {
  const consent = localStorage.getItem('consent');
  const id = process.env.REACT_APP_GA4_ID;
  if (consent !== 'granted' || !id) return;
  if (window.gtag) return; // already loaded
  window.dataLayer = window.dataLayer || [];
  const gtag: GtagFn = (...args: any[]) => {
    window.dataLayer!.push(args);
  };
  window.gtag = gtag as any;
  gtag('js', new Date());
  gtag('config', id);
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
}

function emitEvent(name: string, params?: Record<string, any>) {
  if (window.gtag) {
    window.gtag('event', name, params || {});
  } else {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
  }
}

export function trackAddToCart(params: {
  sku: string;
  name: string;
  variant?: string;
  price: number;
  qty: number;
}) {
  emitEvent('add_to_cart', params);
}

export function trackViewCart(params: { value: number; items_count: number }) {
  emitEvent('view_cart', params);
}

export function trackBeginCheckout(params: { value: number; items_count: number }) {
  emitEvent('begin_checkout', params);
}

export function trackClickWhatsApp(source: string) {
  emitEvent('click_whatsapp', { source });
}

export function trackClickInstagram() {
  emitEvent('click_instagram');
}
